import { hbs } from 'ember-cli-htmlbars';
import { workflowComponent } from '@banking/ui/services/unit-balance';
import { ActionCreator } from '@banking/ui/workflows/balance';
import { formatNumber } from '@banking/ui/utils/checking/utils';

// For the template

const formatAccountNumber = accountNumber => formatNumber(accountNumber, [9, 6, 3]);
const formatRoutingNumber = routingNumber => formatNumber(routingNumber, [6, 3]);
const template = hbs`
<div ...attributes>
  <Banking::Balance::DoMoreCard::Base
    @accountNumber={{this.directDepositAccountNumber}}
    @canSeePrintableCheck={{this.canSeePrintableCheck}}
    @isToggleDisabled={{this.isToggleDisabled}}
    @onBillPayClick={{this.onBillPayClick}}
    @onOpenCreatePrintableCheckClick={{this.onOpenCreatePrintableCheckClick}}
    @onShowAccountDetailsToggle={{this.onShowAccountDetailsToggle}}
    @onStatementsClick={{this.onStatementsClick}}
    @printableCheckAccessConfiguration={{this.printableCheckAccessConfiguration}}
    @routingNumber={{this.directDepositRoutingNumber}}
    @showAccountDetails={{this.showAccountDetails}}
    @showAccountInformation={{this.showAccountInformation}}
    @showBillPay={{this.showBillPay}}
    @showStatements={{this.showStatements}}/>

  <Banking::Market::Modal::Partial
    banking-applet-engine-styles
    data-test-n-plus-one-modal
    data-market-features="typography"
    @active={{this.authModalActive}}>
    <Banking::Common::NPlusOneAuthorization
      @authState={{this.authState}}
      @isResendButtonActive={{this.isResendButtonActive}}
      @onCloseAuthModal={{this.onCloseAuthModal}}
      @onNextClick={{this.onAuthModalNextClick}}
      @onResendEmailClick={{this.onAuthModalResendEmailClick}}
      @onValueChange={{this.onAuthValueChange}}/>
  </Banking::Market::Modal::Partial>

  <Banking::Market::Modal::Full
    banking-applet-engine-styles
    data-test-bill-pay-help-modal
    data-market-features="typography"
    @active={{this.billPayModalActive}}
    @onActiveChange={{this.onBillPayModalActiveChange}}>
    <market-header close-button-aria-label="close" show-navigation/>
    <main>
      <Banking::BillPay::Help @billPayData={{this.billPayData}}/>
    </main>
  </Banking::Market::Modal::Full>
</div>
`;

// TODO(steckel): Consider if the masking should be done via translations.
// e.g.
// ```
// intl.t('banking.components.accountDetailsCard.accountNumber.masked', {
//   accountNumberSuffix,
//   htmlSafe: true,
// });
// ```
const directDepositAccountNumber = state => state.showAccountDetails ? formatAccountNumber(state.directDepositAccount?.accountNumber ?? '') : `•••• ${state.directDepositAccount?.accountNumberSuffix}`;
const showAccountInformation = state => state.directDepositAccount?.accountNumber != null && state.directDepositAccount?.routingNumber != null;
const mapStateToProps = state => ({
  authModalActive: state.authModalActive,
  authState: state.authStateResult,
  billPayData: state.billPayData,
  billPayModalActive: state.billPayModalActive,
  canSeePrintableCheck: state.canSeePrintableCheck,
  createPrintableCheckUnrecoverableError: state.createPrintableCheckUnrecoverableError,
  isToggleDisabled: state.isToggleDisabled,
  directDepositAccountNumber: directDepositAccountNumber(state),
  directDepositRoutingNumber: formatRoutingNumber(state.directDepositAccount?.routingNumber ?? ''),
  isResendButtonActive: state.isResendButtonActive,
  printableCheckAccessConfiguration: state.printableCheckAccessConfiguration,
  showAccountInformation: showAccountInformation(state),
  showAccountDetails: state.showAccountDetails,
  showBillPay: state.showBillPayModal,
  showCheckSuccess: state.showCheckSuccess,
  showCheckError: state.showCheckError,
  showStatements: state.showStatements
});
const mapActionsToProps = () => ({
  onAuthModalNextClick: ActionCreator.userClickSubmitAuthCode,
  onAuthModalResendEmailClick: ActionCreator.userClickResendCode,
  onAuthValueChange: ActionCreator.userChangeAuthCode,
  onBillPayClick: ActionCreator.userClickPayBills,
  onBillPayModalActiveChange: active => active ? null : ActionCreator.userClickDismissBillPayModal(),
  onCloseAuthModal: () => ActionCreator.systemToggleAuthModal(false),
  onOpenCreatePrintableCheckClick: ActionCreator.userClickOpenCreatePrintableCheck,
  onShowAccountDetailsToggle: ActionCreator.userToggleAccountDetails,
  onStatementsClick: ActionCreator.userClickStatementsAndDocuments
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);